import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import {
  selectDecompDataAnalisada,
  selectDecompModo,
} from 'redux/reducers/relatoriosDecompReducer';
import { DecompSecaoParams } from 'types/Relatorios/Decomp';

/**
 * Deriva os params compartilhados das abas DECOMP (`data_rodada` ISO + `modo`)
 * a partir do slice. `useMemo` sobre os primitivos `[ano, mes, dia, modo]`
 * (NÃO sobre o objeto do selector, que retorna nova ref a cada render) e
 * devolve uma referência estável enquanto os valores não mudarem — evita
 * refetch desnecessário do RTK Query.
 */
export default function useDecompSecaoParams(): DecompSecaoParams {
  const { ano, mes, dia } = useSelector(selectDecompDataAnalisada);
  const modo = useSelector(selectDecompModo);

  return useMemo(() => {
    const mm = String(mes).padStart(2, '0');
    const dd = String(dia).padStart(2, '0');
    return { data_rodada: `${ano}-${mm}-${dd}`, modo };
  }, [ano, mes, dia, modo]);
}
